/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { isArrayNotEmpty } from "utils/empty-exists";

const SearchFilterBar = (props) => {
    
    const {
        categories,
        onChangeTerm,
        onChangeCategory,
        runSearch,
        // type = 'model.page'
    } = props;
    
    const [term,setTerm] = useState();
    const [category,setCategory] = useState();
    
    const onChangeSearchTerm = (event) => {
        const value = event.target.value;
        setTerm(value);
        onChangeTerm(value);
    };
    
    const handleCategory = (event) => {
        const value = event.target.value;
        setCategory(value);
        if (value === "All") {
            onChangeCategory(undefined);
        } else {
            setCategory(value);
            onChangeCategory(value);
        }
    };
    const handleSearch = () => {
        runSearch();
    };
    const handleKeyDown = async (event) => {
        if (event.key === "Enter") {
            runSearch();
        }
    };
    
    return (
        <div className="view-filters">
            <div className="feed-search-bar feed-search-root">
                <div className={"feed-search-inputContainer"}>
                    {isArrayNotEmpty(categories) &&
                        <>
                            <label htmlFor="edit-category">
                                Filter Category
                            </label>
                            <div className="search-select">
                                <select
                                    id="edit-category"
                                    name="category"
                                    className="form-select"
                                    value={category}
                                    onChange={handleCategory}
                                >
                                    {categories.map((category) => {
                                        return (
                                            <option
                                                key={category.value}
                                                value={category.value}
                                            >
                                                {category.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </>
                    }
                </div>
                
                <div className={"feed-search-inputContainer"}>
                    <label htmlFor="edit-keywords">
                        Keywords
                    </label>
                    <input
                        value={term}
                        onChange={onChangeSearchTerm}
                        onKeyDown={handleKeyDown}
                        className={"feed-search-input"}
                        type="text"
                        id="edit-keywords"
                        name="keywords"
                        size="30"
                        maxLength="128"
                        // className="form-text"
                    />
                </div>
                
                <div className={"feed-search-inputContainer"}>
                    <div>&nbsp;</div>
                    <button
                        type="submit"
                        className={"feed-search-button"}
                        aria-label="Submit the search query"
                        onClick={handleSearch}
                    >
                        Search
                    </button>
                </div>
            </div>
        </div>
    );
};

export { SearchFilterBar };
